'use strict';
const LATEST_ITEMS = 'LATEST_ITEMS';
const LATEST_ITEMS_LOAD_MORES = 'LATEST_ITEMS_LOAD_MORES';
const ITEM_DETAILS = 'ITEM_DETAILS';
const GET_ITEM_DETAILS = 'GET_ITEM_DETAILS';
const CATEGORY_HIERARCHY = 'CATEGORY_HIERARCHY';
const HOMEPAGE_SHOW_ALL_CATEGORIES = 'HOMEPAGE_SHOW_ALL_CATEGORIES';
const HOMEPAGE_SHOW_4_CATEGORIES = 'HOMEPAGE_SHOW_4_CATEGORIES';
const FETCH_PANELS = 'FETCH_PANELS';
const FETCH_CATEGORIES = 'FETCH_CATEGORIES';
const CURRENT_USER = 'CURRENT_USER';
const BUYER = 'buyer';
const SELLER = 'seller';
const LOGOUT = 'logout';
const FETCH_PURCHASES = 'FETCH_PURCHASES';
const GO_TO_PAGE = 'GO_TO_PAGE';
const FETCH_ORDERS = 'FETCH_ORDERS';
const FETCH_STOREFRONTITEMS = 'FETCH_STOREFRONTITEMS';
const UPDATE_STOREFRONTKEYWORD = 'UPDATE_STOREFRONTKEYWORD';
const SELECT_UNSELECT_ORDER = 'SELECT_UNSELECT_ORDER';
const UPDATE_SELECTED_ORDER_STATUS = 'UPDATE_SELECTED_ORDER_STATUS';
const UPDATE_SELECTED_CART_ITEM_ORDER_STATUS = 'UPDATE_SELECTED_CART_ITEM_ORDER_STATUS';
const UPDATE_HISTORY_ORDERS = 'UPDATE_HISTORY_ORDERS';
const UPDATE_DETAIL_ORDER = 'UPDATE_DETAIL_ORDER';
const SHOW_HIDE_CHANGE_STATUS = 'SHOW_HIDE_CHANGE_STATUS';
const SHOW_HIDE_SUCCESS_MESSAGE = 'SHOW_HIDE_SUCCESS_MESSAGE';
const REVERT_ORDER_PAYMENT = 'REVERT_ORDER_PAYMENT';
const FETCH_MESSAGES = 'FETCH_MESSAGES';
const CREATE_ADDRESS = 'CREATE_ADDRESS';
const UPDATE_ADDRESS = 'UPDATE_ADDRESS';
const DELETE_ADDRESS = 'DELETE_ADDRESS';
const UPDATE_ITEMDETAILQUANTITY = 'UPDATE_ITEMDETAILQUANTITY';
const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
const UPDATE_INBOXSEARCHTEXT = 'UPDATE_INBOXSEARCHTEXT';
const GET_UNREAD_COUNT = 'GET_UNREAD_COUNT';
const SEARCH_ITEMS = 'SEARCH_ITEMS';
const SORT_SEARCH_RESULT = 'SORT_SEARCH_RESULT';
const SEARCH_BY_FILTERS = 'SEARCH_BY_FILTERS';
const SET_SEARCH_RESULT_DISPLAY = 'SET_SEARCH_RESULT_DISPLAY';
const UPDATE_CHECKOUT_SELECTED_DELIVERY_ADDRESS = 'UPDATE_CHECKOUT_SELECTED_DELIVERY_ADDRESS';
const FETCH_CUSTOM_FIELDS = 'FETCH_CUSTOM_FIELDS';
const CHECKOUT_REVIEW_CHANGE_DELIVERY = 'CHECKOUT_REVIEW_CHANGE_DELIVERY';
const FETCH_EVENTS = 'FETCH_EVENTS';
const UPDATE_SELECTED_SECTION = 'UPDATE_SELECTED_SECTION';
const UPDATE_SELECTED_TAB_SECTION = 'UPDATE_SELECTED_TAB_SECTION';
const SET_UPLOAD_FILE = 'SET_UPLOAD_FILE';
const CREATE_ORDER_DIARY_EVENT = 'CREATE_ORDER_DIARY_EVENT';
const SEARCH_BY_CATEGORY = 'SEARCH_BY_CATEGORY';
const GET_REPORTS = 'GET_REPORTS';
const GET_TRANSACTIONS = 'GET_TRANSACTIONS';
const GET_HEADER_TRANSACTION = 'GET_HEADER_TRANSACTION';
const GET_USER_COMPARISONS = 'GET_USER_COMPARISONS';
const GET_COMPARISON = 'GET_COMPARISON';
const CREATE_COMPARISON = 'CREATE_COMPARISON';
const EDIT_COMPARISON = 'EDIT_COMPARISON';
const SET_PROCESSING_COMPARISONDETAILS = 'SET_PROCESSING_COMPARISONDETAILS';
const SET_COMPARISON_TO_UPDATE = 'SET_COMPARISON_TO_UPDATE';
const CREATE_EVALUATION = "CREATE_EVALUATION";
const EDIT_EVALUATION = "EDIT_EVALUATION";
const DELETE_EVALUATION = "DELETE_EVALUATION";
const SET_EVALUATION_TO_UPDATE = "SET_EVALUATION_TO_UPDATE";
const SET_COMPARISON_DETAIL_TO_UPDATE = 'SET_COMPARISON_DETAIL_TO_UPDATE';
const DELETE_COMPARISON_DETAIL = 'DELETE_COMPARISON_DETAIL';
const CREATE_COMPARISON_DETAIL = 'CREATE_COMPARISON_DETAIL';
const UPDATE_COMPARISON_DETAIL = 'UPDATE_COMPARISON_DETAIL';
const ADD_EDIT_CART = 'ADD_EDIT_CART';
const PROCESSING = 'PROCESSING';
const GET_MARKETPLACE_INFO = 'GET_MARKETPLACE_INFO';
const GET_MARKETPLACE_REGISTRATION = 'GET_MARKETPLACE_REGISTRATION';

const UPDATE_LISTING_NAME = 'UPDATE_LISTING_NAME';
const UPDATE_ITEM_UPLOAD_EDIT_CATEGORIES_TO_SEARCH = 'UPDATE_ITEM_UPLOAD_EDIT_CATEGORIES_TO_SEARCH';
const ITEM_UPLOAD_EDIT_SELECT_UNSELECT_CATEGORY = 'ITEM_UPLOAD_EDIT_SELECT_UNSELECT_CATEGORY';
const ITEM_UPLOAD_EDIT_UPDATE_DATA = 'ITEM_UPLOAD_EDIT_UPDATE_DATA';
const ITEM_UPLOAD_EDIT_GET_CUSTOMFIELDS = 'ITEM_UPLOAD_EDIT_GET_CUSTOMFIELDS';
const ITEM_UPLOAD_EDIT_MODAL_CHANGE = 'ITEM_UPLOAD_EDIT_MODAL_CHANGE';
const GET_SHIPPING_OPTIONS_MERCHANT = 'GET_SHIPPING_OPTIONS_MERCHANT';
const GET_SHIPPING_OPTIONS_ADMIN = 'GET_SHIPPING_OPTIONS_ADMIN';
const GET_PICKUP_LOCATION = 'GET_PICKUP_LOCATION';

const FETCH_ACTIVITYLOG = 'FETCH_ACTIVITYLOG';
const EXPORT_MERCHANT_LOG = 'EXPORT_MERCHANT_LOG';

const EDIT_ITEM_PURCHASABLE = 'EDIT_ITEM_PURCHASABLE';
const SET_ITEM_TO_DELETE = 'SET_ITEM_TO_DELETE';
const DELETE_ITEM = 'DELETE_ITEM';
const DELETE_SHIPPING_METHOD = 'DELETE_SHIPPING_METHOD';
const CREATE_SHIPPING_METHOD = 'CREATE_SHIPPING_METHOD';
const UPDATE_SHIPPING_METHOD = 'UPDATE_SHIPPING_METHOD';

const GET_SUB_ACCOUNTS = 'GET_SUB_ACCOUNTS';
const SET_USER_TO_DELETE = 'SET_USER_TO_DELETE';
const DELETE_USER = 'DELETE_USER';
const SEND_SUB_MERCHANT_INVITES = 'SEND_SUB_MERCHANT_INVITES';
const CREATE_PURCHASE_DETAIL = 'CREATE_PURCHASE_DETAIL';

const GET_CONTENT_PAGES = 'GET_CONTENT_PAGES';
const SEND_OFFER = 'SEND_OFFER';
const UPDATE_OFFER = 'UPDATE_OFFER';
const GET_CHANNELS = 'GET_CHANNELS';
const CONTACT_SELLER = 'CONTACT_SELLER';
const CREATE_CHAT_CHANNEL = 'CREATE_CHAT_CHANNEL';
const SEND_CHAT_MESSAGE = 'SEND_CHAT_MESSAGE';

const RESET_PASSWORD = "RESET_PASSWORD";
const GET_ADDRESS = 'GET_ADDRESS';
const SEND_EMAIL = 'SEND_EMAIL';
const CREATE_CUSTOM_FIELD = 'CREATE_CUSTOM_FIELD';
const GET_OFFER = 'GET_OFFER';
const CREATE_PAYMENT_ACCEPTANCE_METHOD = 'CREATE_PAYMENT_ACCEPTANCE_METHOD'
const GET_PAYMENT_ACCEPTANCE_METHOD = "GET_PAYMENT_ACCEPTANCE_METHOD";

const FETCH_DETAIL = 'FETCH_DETAIL';

const GET_USER_CARTS = 'GET_USER_CARTS';
const GET_CART_STATES = "GET_CART_STATES";
const CREATE_USER_CUSTOM_FIELD = 'CREATE_USER_CUSTOM_FIELD';

const CHECKOUT_REVIEW_UPDATE_DELIVERY_MAP = 'CHECKOUT_REVIEW_UPDATE_DELIVERY_MAP';

const UPDATE_CHECKOUT_SELECTED_PAYMENT_METHOD = 'UPDATE_CHECKOUT_SELECTED_PAYMENT_METHOD';

const UPDATE_STOREFRONT_MERCHANT_REVIEW = "UPDATE_STOREFRONT_MERCHANT_REVIEW";

const ADD_PAYMENT_TERM = "ADD_PAYMENT_TERM";
const DELETE_PAYMENT_TERM = "DELETE_PAYMENT_TERM";
const UPDATE_PAYMENT_TERM = "UPDATE_PAYMENT_TERM";

const UPDATE_SUB_ACCOUNT_KEYWORD = "UPDATE_SUB_ACCOUNT_KEYWORD";
const SET_SUB_ACCOUNT_TO_DELETE = "SET_SUB_ACCOUNT_TO_DELETE";
const DELETE_SUB_ACCOUNT = "DELETE_SUB_ACCOUNT";
const ADD_CHANNEL_MEMBER = "ADD_CHANNEL_MEMBER";

const GET_APPROVAL_SETTINGS = 'GET_APPROVAL_SETTINGS';
const UPDATE_APPROVAL_SETTINGS = 'UPDATE_APPROVAL_SETTINGS';
const UPDATE_APPROVAL_LIST = 'UPDATE_APPROVAL_LIST';
const UPDATE_APPROVAL_FILTERS = 'UPDATE_APPROVAL_FILTERS';

//ONE-PAGE-CHECKOUT
const UPDATE_SELECTED_BUYER_ADDRESS = 'UPDATE_SELECTED_BUYER_ADDRESS';
const UPDATE_SELECTED_ADDRESS = 'UPDATE_SELECTED_ADDRESS';
const UPDATE_ADD_ADDRESS = 'UPDATE_ADD_ADDRESS';
const UPDATE_DELETE_ADDRESS = 'UPDATE_DELETE_ADDRESS';
const UPDATE_INVOICE_DETAILS = 'UPDATE_INVOICE_DETAILS';
const UPDATE_ORDER_DETAILS = 'UPDATE_ORDER_DETAILS';
const UPDATE_USER_INFO_ONE_PAGE_CHECKOUT = 'UPDATE_USER_INFO_ONE_PAGE_CHECKOUT';
const UPDATE_PAYMENT_PROCEED = 'UPDATE_PAYMENT_PROCEED';
const INVALID_CHECKOUT = 'INVALID_CHECKOUT';
const GET_QUOTATIONS = "GET_QUOTATIONS";

const CREATE_BILLING_ADDRESS = 'CREATE_BILLING_ADDRESS';
const UPDATE_SELECTED_BILLING_ADDRESS = 'UPDATE_SELECTED_BILLING_ADDRESS';
const DELETE_CHECKOUT_ADDRESSES = 'DELETE_CHECKOUT_ADDRESSES';
const UPDATE_IS_SAME_BILLING_AND_DELIVERY_ADDRESS = 'UPDATE_IS_SAME_BILLING_AND_DELIVERY_ADDRESS';
const CLEAR_ADD_ADDRESS_MODAL = 'CLEAR_ADD_ADDRESS_MODAL';
const GET_REQUISITIONS = "GET_REQUISITIONS"
const SET_REQUISITION_STATUSFILTER = "SET_REQUISITION_STATUSFILTER";
const SET_REQUISITION_SUPPLIERFILTER = "SET_REQUISITION_SUPPLIERFILTER";

const UPDATE_HAS_APPROVED_OR_REJECT = "UPDATE_HAS_APPROVED_OR_REJECT";

const UPDATE_SELECTED_SUPPLIERS = "UPDATE_SELECTED_SUPPLIERS";
const UPDATE_SELECTED_DATES_PO = "UPDATE_SELECTED_DATES_PO";
const UPDATE_SELECTED_WORD_PO = "UPDATE_SELECTED_WORD_PO";

const GET_RECEIVING_NOTES = "GET_RECEIVING_NOTES";
const UPDATE_RECEIVING_NOTE = "UPDATE_RECEIVING_NOTE";

const GET_INVOICES = "GET_INVOICES"; 
const SET_INVOICE_ORDER_STATUS = "SET_INVOICE_ORDER_STATUS";
const UPDATE_INVOICE_STATUS = "UPDATE_INVOICE_STATUS";

const FEEDBACK_REPLY_SELECTED = "FEEDBACK_REPLY_SELECTED";
const UPDATE_MESSAGE = "UPDATE_MESSAGE";

const UPDATE_BOOKING_SLOT = "UPDATE_BOOKING_SLOT";

const UPDATE_DETAIL_ORDER_PAYMENT_STATUS = 'UPDATE_DETAIL_ORDER_PAYMENT_STATUS';
module.exports = {
    LATEST_ITEMS,
    ITEM_DETAILS,
    GET_ITEM_DETAILS,
    CATEGORY_HIERARCHY,
    HOMEPAGE_SHOW_ALL_CATEGORIES,
    HOMEPAGE_SHOW_4_CATEGORIES,
    LATEST_ITEMS_LOAD_MORES,
    CURRENT_USER,
    BUYER,
    SELLER,
    LOGOUT,
    FETCH_PANELS,
    FETCH_CATEGORIES,
    FETCH_PURCHASES,
    FETCH_DETAIL,
    GO_TO_PAGE,
    FETCH_ORDERS,
    FETCH_MESSAGES,
    FETCH_STOREFRONTITEMS,
    UPDATE_STOREFRONT_MERCHANT_REVIEW,
    UPDATE_INBOXSEARCHTEXT,
    GET_UNREAD_COUNT,
    UPDATE_STOREFRONTKEYWORD,
    SELECT_UNSELECT_ORDER,
    UPDATE_SELECTED_ORDER_STATUS,
    UPDATE_SELECTED_CART_ITEM_ORDER_STATUS,
    UPDATE_HISTORY_ORDERS,
    UPDATE_DETAIL_ORDER,
    SHOW_HIDE_CHANGE_STATUS,
    SHOW_HIDE_SUCCESS_MESSAGE,
    REVERT_ORDER_PAYMENT,
    CREATE_ADDRESS,
    UPDATE_ADDRESS,
    DELETE_ADDRESS,
    UPDATE_ITEMDETAILQUANTITY,
    UPDATE_USER_INFO,
    SEARCH_ITEMS,
    SEARCH_BY_FILTERS,
    SORT_SEARCH_RESULT,
    SET_SEARCH_RESULT_DISPLAY,
    UPDATE_CHECKOUT_SELECTED_DELIVERY_ADDRESS,
    FETCH_CUSTOM_FIELDS,
    CHECKOUT_REVIEW_CHANGE_DELIVERY,
    FETCH_EVENTS,
    UPDATE_SELECTED_SECTION,
    UPDATE_SELECTED_TAB_SECTION,
    SET_UPLOAD_FILE,
    CREATE_ORDER_DIARY_EVENT,
    SEARCH_BY_CATEGORY,
    GET_REPORTS,
    GET_TRANSACTIONS,
    GET_HEADER_TRANSACTION,
    UPDATE_LISTING_NAME,
    UPDATE_ITEM_UPLOAD_EDIT_CATEGORIES_TO_SEARCH,
    ITEM_UPLOAD_EDIT_SELECT_UNSELECT_CATEGORY,
    ITEM_UPLOAD_EDIT_GET_CUSTOMFIELDS,
    ITEM_UPLOAD_EDIT_MODAL_CHANGE,
    GET_USER_COMPARISONS,
    GET_COMPARISON,
    CREATE_COMPARISON,
    EDIT_COMPARISON,
    SET_PROCESSING_COMPARISONDETAILS,
    SET_COMPARISON_TO_UPDATE,
    CREATE_EVALUATION,
    EDIT_EVALUATION,
    DELETE_EVALUATION,
    SET_EVALUATION_TO_UPDATE,
    SET_COMPARISON_DETAIL_TO_UPDATE,
    DELETE_COMPARISON_DETAIL,
    CREATE_COMPARISON_DETAIL,
    UPDATE_COMPARISON_DETAIL,
    ADD_EDIT_CART,
    GET_USER_CARTS,
    GET_CART_STATES,
    FETCH_ACTIVITYLOG,
    EXPORT_MERCHANT_LOG,
    PROCESSING,
    GET_MARKETPLACE_INFO,
    GET_SHIPPING_OPTIONS_MERCHANT,
    GET_SHIPPING_OPTIONS_ADMIN,
    GET_PICKUP_LOCATION,
    EDIT_ITEM_PURCHASABLE,
    DELETE_ITEM,
    SET_ITEM_TO_DELETE,
    GET_SUB_ACCOUNTS,
    SET_USER_TO_DELETE,
    DELETE_USER,
    SEND_SUB_MERCHANT_INVITES,
    DELETE_SHIPPING_METHOD,
    ITEM_UPLOAD_EDIT_UPDATE_DATA,
    CREATE_PURCHASE_DETAIL,
    CREATE_SHIPPING_METHOD,
    UPDATE_SHIPPING_METHOD,
    GET_CONTENT_PAGES,
    SEND_OFFER,
    UPDATE_OFFER,
    CONTACT_SELLER,
    GET_CHANNELS,
    CREATE_CHAT_CHANNEL,
    SEND_CHAT_MESSAGE,
    RESET_PASSWORD,
    GET_ADDRESS,
    SEND_EMAIL,
    CREATE_CUSTOM_FIELD,
    GET_OFFER,
    CREATE_USER_CUSTOM_FIELD,
    CREATE_PAYMENT_ACCEPTANCE_METHOD,
    GET_PAYMENT_ACCEPTANCE_METHOD,
    CHECKOUT_REVIEW_UPDATE_DELIVERY_MAP,
    UPDATE_CHECKOUT_SELECTED_PAYMENT_METHOD,
    ADD_PAYMENT_TERM,
    DELETE_PAYMENT_TERM,
    UPDATE_PAYMENT_TERM,
    UPDATE_SUB_ACCOUNT_KEYWORD,
    SET_SUB_ACCOUNT_TO_DELETE,
    DELETE_SUB_ACCOUNT,
    ADD_CHANNEL_MEMBER,
    UPDATE_APPROVAL_SETTINGS,
    GET_APPROVAL_SETTINGS,
    UPDATE_APPROVAL_LIST,
    UPDATE_APPROVAL_FILTERS,
    UPDATE_SELECTED_ADDRESS,
    UPDATE_SELECTED_BUYER_ADDRESS,
    UPDATE_ADD_ADDRESS,
    UPDATE_DELETE_ADDRESS,
    UPDATE_INVOICE_DETAILS,
    UPDATE_ORDER_DETAILS,
    UPDATE_USER_INFO_ONE_PAGE_CHECKOUT,
    UPDATE_PAYMENT_PROCEED,
    INVALID_CHECKOUT,
    GET_QUOTATIONS,

    GET_REQUISITIONS,
    SET_REQUISITION_STATUSFILTER,
    SET_REQUISITION_SUPPLIERFILTER,
    UPDATE_HAS_APPROVED_OR_REJECT,

    CREATE_BILLING_ADDRESS,
    UPDATE_SELECTED_BILLING_ADDRESS,
    DELETE_CHECKOUT_ADDRESSES,
    CLEAR_ADD_ADDRESS_MODAL,
    UPDATE_IS_SAME_BILLING_AND_DELIVERY_ADDRESS,

    UPDATE_SELECTED_SUPPLIERS,
    UPDATE_SELECTED_DATES_PO,
    UPDATE_SELECTED_WORD_PO,

    GET_RECEIVING_NOTES,
    UPDATE_RECEIVING_NOTE,

    GET_INVOICES, 
    SET_INVOICE_ORDER_STATUS,
    UPDATE_INVOICE_STATUS,

    FEEDBACK_REPLY_SELECTED,
    UPDATE_MESSAGE, 

    UPDATE_DETAIL_ORDER_PAYMENT_STATUS,

    UPDATE_BOOKING_SLOT
};
